import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { ensureUserHasRoleAdminSite } from '../../auth/authComponents';
import Utils, { SecurityRoles as roles, AdjudicationStatus } from '../../common/utils';

import { Page, PageContent, PageHeader } from '../../components/common';
import { TextInput } from '../../components/forms';
// import Button from '../../components/buttons/Button';

import AdjudicationList from '../adjudication/AdjudicationList';

import policyActions from '../../policy/policyActions';
import userActions from '../../user/userActions';

// import * as toastr from 'toastr';

interface Props {
	actions: any;
	history?: any;
	match?: any;
	softDeclinedCustomers: SoftDeclinedUserDetailsDto[];
}

interface State {
	isLoading: boolean;
	searchterm: string;
	softDeclinedCustomers: SoftDeclinedUserDetailsDto[];
}

class AdjudicationListPage extends React.Component<Props, State> {
	handleSearchDebounced = Utils.debounce(() => this.search(this.state.searchterm), 200);

	constructor(props: any) {
		super(props);
		this.state = {
			isLoading: true,
			searchterm: '',
			softDeclinedCustomers: []
		};
	}

	componentDidMount() {
		this.loadData();
	}

	loadData = () => {
		this.setState({ isLoading: true });
		this.props.actions.fetchSoftDeclinedCustomers()
		.then(() => {
			const displayCustomers = this.props.softDeclinedCustomers
			.filter(c => c.customerPolicy!.adjudicationStatusId !== AdjudicationStatus.Rejected);
			this.setState({ isLoading: false, softDeclinedCustomers: displayCustomers });
		});
	}

	onSearch = (e: any) => {
		this.setState({ searchterm: e.target.value }, () => {
			this.handleSearchDebounced();
		});
	}
	search = (searchterm: string) => {
		const value = searchterm.toLowerCase();
		const displayCustomers = this.props.softDeclinedCustomers
			.filter(c => c.customerPolicy!.adjudicationStatusId !== AdjudicationStatus.Rejected);
		let softDeclinedCustomers = displayCustomers.filter(function (c: UserDetails) {
			let fullName = c.fullName || '';
			let email = c.email || '';
			return fullName.toLowerCase().startsWith(value) || email.toLowerCase().startsWith(value);
		});

		this.setState({ softDeclinedCustomers });
	}

	onAddNotesClick = (e: any, userId: string) => {
		e.stopPropagation();
		this.props.history.push(`/admin/prospects/${userId}/notes`);
	}

	/*
	clearQueue = () => {
		this.setState({ isLoading: true });
		this.props.actions.clearAdjudicationQueue()
		.then(() => this.loadData())
		.then(() => toastr.success('Adjudication queue cleared'))
		.then(() => this.setState({ isLoading: false }));
	}
	*/

	render() {
		return (
			<Page title="Soft Declined Customers">
			<PageContent>
				<PageHeader title="Soft Declined Customers" />
				<div className="row mb-3">
					<div className="col-sm-4">
						<TextInput
							name="search"
							placeholder="Search"
							value={this.state.searchterm}
							onChange={this.onSearch}
							className="mb-3 mb-sm-0 table-search"
						/>
					</div>
					{/*
					<div className="col-auto ml-auto">
						<Button
							className="btn-primary"
							onClick={this.clearQueue}
						>
							Clear Queue
						</Button>
					</div>
					*/}
				</div>
				<AdjudicationList
					softDeclinedCustomers={this.state.softDeclinedCustomers}
					history={this.props.history}
					isLoading={this.state.isLoading}
					onAddNotesClick={this.onAddNotesClick}
					setRedirectFromAdjudication={this.props.actions.setRedirectFromAdjudication}
				/>
				</PageContent>
			</Page>
		);
	}
}

function mapStateToProps(state: any) {
	return {
		softDeclinedCustomers: state.user.softDeclinedCustomers
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...policyActions, ...userActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}

const connectedPage = connect(mapStateToProps, mapDispatchToProps)(AdjudicationListPage);
const adminRoles = [roles.Administrator, roles.Agent, roles.Adjudicator];
export default ensureUserHasRoleAdminSite(connectedPage as any, adminRoles);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/adjudication/AdjudicationListPage.tsx